export enum EventsEnum {
  initiateCheckout = 'initiateCheckout',
}
